module.exports = __webpack_public_path__ + "img/c05_unitscorpio_Normal_ua.5497e65c.webp";